import { Dictionary } from '@hkm/shared/dictionaries/dictionary';

export const PostingDictionaries: Set<Dictionary> = new Set<Dictionary>()
  .add(Dictionary.RoomStatus)
  .add(Dictionary.Room);



// WEBPACK FOOTER //
// ./src/components/Posting/shared/config/postingDictionaries.ts